"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var EmailLink = function EmailLink(props) {
  var children = props.children,
      className = props.className,
      icon = props.icon,
      iconClassName = props.iconClassName,
      noIcon = props.noIcon,
      title = props.title,
      restProps = _objectWithoutProperties(props, ["children", "className", "icon", "iconClassName", "noIcon", "title"]);

  return _react2.default.createElement(
    "a",
    _extends({
      className: (0, _classnames2.default)("erg-components-EmailLink", "erg-link", className),
      href: "mailto:" + children,
      title: title
    }, restProps),
    !noIcon && _react2.default.createElement(_Icon2.default, { className: iconClassName, icon: icon }),
    children
  );
};

EmailLink.defaultProps = {
  icon: "envelope",
  noIcon: false
};

EmailLink.displayName = "EmailLink";

EmailLink.propTypes = {
  children: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  iconClassName: _propTypes2.default.string,
  noIcon: _propTypes2.default.bool,
  title: _propTypes2.default.string
};

exports.default = EmailLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/EmailLink.js
 ** module id = 781
 ** module chunks = 0
 **/